/**
 * @generated SignedSource<<10235a77b158c220c2cec110bad297df>>
 * @relayHash 519ab2a53c4df2c9d06fac9d39d3cd7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 161a08af42ab7afb03887af7040bdd8daed8b94927b1e99c456602011fd7f392

import type { ConcreteRequest } from 'relay-runtime';
export type CardLoadingByIdentityQuery$variables = {
  accountId: string;
};
export type CardLoadingByIdentityQuery$data = {
  readonly user: {
    readonly __typename: "AppUser";
    readonly appType: string | null;
    readonly extendedProfile: {
      readonly aboutMe: string | null;
      readonly jobTitle: string | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type CardLoadingByIdentityQuery = {
  response: CardLoadingByIdentityQuery$data;
  variables: CardLoadingByIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appType"
    },
    {
      "concreteType": "AppUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        },
        {
          "kind": "ScalarField",
          "name": "aboutMe"
        }
      ]
    }
  ],
  "type": "AppUser"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CardLoadingByIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CardLoadingByIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "161a08af42ab7afb03887af7040bdd8daed8b94927b1e99c456602011fd7f392",
    "metadata": {},
    "name": "CardLoadingByIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b49652c3a49c742749aa2056ecc5fe74";

export default node;
